import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';

import ProjectsContent from '../components/ProjectsContent';

export default function Projects() {
  return (
    <div className='container mt-2'>
      <Header />
      <ProjectsContent />
      <hr />
      <Footer />
    </div>
  );
}
